<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="handleAddEvent($event)"
		[isImportable]="isImportable"
		(importingEvent)="uploader.click()"
		[isExportable]="isExportable"
		(exportingEvent)="exportFormations()"
	></app-nav-gestion-donnees>

	<input hidden type="file" #uploader (change)="importFormations($event)" />
	<div class="my-3">
		<div class="my-2">
			<div
				class="theme-main-color d-flex ps-lg-0"
				[ngClass]="{ row: isMobile }"
			>
				<app-week-selector
					[weekNumber]="weeknumber"
					[yearNumber]="yearnumber"
					[dateRange]="dateRange"
					(dateRangeChange)="dateRangeChange()"
				></app-week-selector>
			</div>

			<div class="row mt-4">
				<button
					[disabled]="listSelectedMissionRequestDelete?.length < 1"
					class="col-2 col-lg-1 btn theme-red-button"
					(click)="deleteMultiple()"
					[ngStyle]="!isMobile ? { width: '5%' } : {}"
				>
					<i class="bi bi-trash-fill" aria-hidden="true"></i>
				</button>
				<div class="col-2 ms-lg-auto">
					<div class="dropdown">
						<a
							class="btn btn-secondary dropdown-toggle"
							role="button"
							id="dropdownFilter"
							data-bs-toggle="dropdown"
							data-bs-auto-close="outside"
							aria-expanded="false"
						>
							<i class="bi bi-filter" aria-hidden="true"></i> Filtrer
						</a>
						<div
							class="dropdown-menu px-3 py-3"
							aria-labelledby="dropdownFilter"
							id="menuFilter"
						>
							<div class="row">
								<span class="theme-main-color form-label">Dates :</span>
								<div class="px-2">
									<input
										class="form-control"
										[(ngModel)]="dateRange.value"
										(ngModelChange)="selectNewDate()"
										#drp="bsDaterangepicker"
										bsDaterangepicker
										type="text"
										id="dateRange"
									/>
								</div>
							</div>
							<div class="row" *ngIf="!isSAAD">
								<span class="theme-main-color form-label">Compétence(s) :</span>
								<div class="">
									<div
										*ngFor="let competence of competences"
										class="form-check"
									>
										<input
											(change)="
												changeCompetencesFilter($event, competence.name)
											"
											class="form-check-input"
											type="checkbox"
											value="{{ competence.name }}"
											id="dd{{ competence.name }}"
										/>
										<label
											class="form-check-label"
											for="dd{{ competence.name }}"
										>
											{{ competence.name.replaceAll('_', ' ') }}
										</label>
									</div>
								</div>
							</div>
							<div class="row" *ngIf="isSAE">
								<span class="theme-main-color form-label">Service(s):</span>
								<div class="mb-1">
									<div
										*ngFor="let department of centerDepartments"
										class="form-check ms-3"
									>
										<input
											(change)="changeDepartmentFilter($event, department)"
											class="form-check-input"
											type="checkbox"
											value="{{ department.name }}"
											id="dd{{ department.name }}"
										/>
										<label class="form-check-label text-dark">
											{{ department.name }}
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-lg-3 col-12">
					<div class="input-group">
						<span class="input-group-text bg-transparent"
							><i class="bi bi-search" aria-hidden="true"></i
						></span>
						<input
							type="text"
							class="form-control border-start-0"
							placeholder="Rechercher un élément..."
							[(ngModel)]="searchedText"
							(change)="searchedTextChange()"
						/>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="!isMobile" class="row mt-4 mb-1">
			<div class="col-2 d-flex justify-content-around">
				<input
					class="form-check-input"
					type="checkbox"
					[checked]="allMissionChecked"
					(change)="selectAllMissionForDelete($event)"
					id="flexCheckDefault"
					[ngClass]="{
						'theme-main-color-check': allMissionChecked
					}"
				/>
				<span
					class="hand-cursor fw-bold flex-grow-1 text-center"
					(click)="sortChange('date')"
					>Date
					<span
						*ngIf="sortType === 'date' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'date' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-1 fw-bold">
				<span class="">Début</span>
			</div>
			<div class="col-1 fw-bold">
				<span class="">Fin</span>
			</div>

			<div class="col-2">
				<span
					class="hand-cursor fw-bold"
					(click)="sortChange('missionType.type')"
					>Type de
					{{ labelIntervention }}
					<span
						*ngIf="sortType === 'missionType.type' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'missionType.type' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>

			<div class="col-2" *ngIf="isSAE">
				<span
					class="fw-bold hand-cursor"
					(click)="sortChange('centerDepartment')"
				>
					Service
					<span
						*ngIf="sortType === 'centerDepartment' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'centerDepartment' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>

			<div class="col-2" *ngIf="isSESSAD">
				<span
					class="hand-cursor fw-bold"
					(click)="sortChange('missionPlace.nameDisplay')"
					>Lieu de {{ labelIntervention }}
					<span
						*ngIf="
							sortType === 'missionPlace.nameDisplay' && sortOrder === 'asc'
						"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="
							sortType === 'missionPlace.nameDisplay' && sortOrder === 'desc'
						"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>

			<div class="col-2" *ngIf="isSESSAD || isSAAD">
				<span
					class="hand-cursor fw-bold"
					(click)="sortChange('careSpecialty.name')"
					>Spécialité
					<span
						*ngIf="sortType === 'careSpecialty.name' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'careSpecialty.name' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>

			<div class="col-2">
				<span
					class="hand-cursor fw-bold"
					(click)="sortChange('beneficiaire.lastName')"
					>{{ labelBeneficiaire | titlecase }}
					<span
						*ngIf="sortType === 'beneficiaire.lastName' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'beneficiaire.lastName' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
		</div>

		<div *ngIf="isMobile">
			<input
				class="col-2 form-check-input"
				type="checkbox"
				[checked]="allMissionChecked"
				(change)="selectAllMissionForDelete($event)"
				id="flexCheckDefault"
			/>
			<label class="form-check-label"> Tout séléctionner</label>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<!-- DEBUT DU LISTING -->
		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let missionRequest of formations
						| filterFormationByAllFields : searchedText
						| filterFormationBySkill : selectedCompetences
						| filterFormationByDepartment : selectedDepartments
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage
							  }
						| orderBy : sortType : sortOrder : ['date', 'readyTime', 'dueTime']
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3"
				[ngClass]="{
					'theme-grey-background-color':
						(isProjectManager || isProfessionnelSAE) &&
						!isFormationIdInProjectManagerArray(missionRequest.id),
					'bg-light':
						(!isProjectManager && !isProfessionnelSAE) ||
						isFormationIdInProjectManagerArray(missionRequest.id),
					'theme-canceled': state[missionRequest.state].includes(
						this.state.CANCELED
					)
				}"
			>
				<span [ngClass]="{ row: isMobile }" class="col-lg-2 d-flex">
					<input
						class="col-12 p-2 ms-3 m-lg-0 p-lg-0 form-check-input"
						type="checkbox"
						(change)="selectMissionForDelete($event, missionRequest)"
						[checked]="isMissionCheckForDelete(missionRequest)"
						id="{{ 'check' + missionRequest.id }}"
						[disabled]="canMissionBeChecked(missionRequest)"
						[ngClass]="{
							'theme-main-color-check': isMissionCheckForDelete(missionRequest)
						}"
					/>
					<span class="flex-grow-1 text-lg-center">
						<span *ngIf="isMobile" class="fw-bold">Date :</span>
						{{ missionRequest?.date | date : 'dd/MM/yy' }}
					</span></span
				>
				<span class="col-lg-1 col-12">
					<span *ngIf="isMobile" class="fw-bold">Début : </span>
					{{ missionRequest?.readyTime | minutesToTime }}
				</span>
				<span class="col-lg-1 col-12">
					<span class="fw-bold" *ngIf="isMobile">Fin :</span>
					{{ missionRequest?.dueTime | minutesToTime }}
				</span>
				<span class="col-lg-2 col-12">
					<span class="fw-bold" *ngIf="isMobile">Type :</span>
					{{ getTypeAndCareSkill(missionRequest) }}</span
				>
				<span class="col-lg-2 col-12" *ngIf="isSAE">
					<span class="fw-bold" *ngIf="isMobile">Service :</span>
					<span *ngIf="missionRequest.centerDepartment">
						<span>{{ missionRequest.centerDepartment.name }}</span>
					</span>
					<span
						style="font-style: italic"
						*ngIf="!missionRequest.centerDepartment"
						>Non-renseigné</span
					>
				</span>
				<span class="col-lg-2 col-12" *ngIf="isSESSAD">
					<span class="fw-bold" *ngIf="isMobile">Lieu :</span>
					{{
						missionRequest?.missionPlace
							? missionRequest?.missionPlace.nameDisplay
							: missionRequest.beneficiaire
							? 'Domicile du ' + labelBeneficiaire
							: ''
					}}</span
				>
				<span class="col-lg-2 col-12" *ngIf="isSESSAD || isSAAD">
					<span class="fw-bold" *ngIf="isMobile">Spécialité :</span>
					{{
						missionRequest?.missionType?.type === MISSION_TYPE_REUNION_TYPE
							? ''
							: missionRequest.careSpecialty?.name
					}}</span
				>
				<div class="col">
					<div class="d-flex">
						<span class="flex-grow-1"
							><span *ngIf="missionRequest.beneficiaire">
								<span class="fw-bold" *ngIf="isMobile">Bénéficiaire :</span>
								{{
									missionRequest.beneficiaire?.firstName +
										' ' +
										missionRequest.beneficiaire?.lastName
								}}
								<!-- + (!isSESSAD
											? ''
											: ' (' +
											  competencesFull[
													missionRequest?.beneficiaire?.careSkill?.name
											  ] +
											  ')') -->
							</span></span
						>
						<i
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
							[class.disabled-link]="
								!(
									(!isProjectManager && !isProfessionnelSAE) ||
									isFormationIdInProjectManagerArray(missionRequest.id)
								) &&
								missionRequest.missionType?.type !== missionTypeName.REUNION
							"
							[routerLink]="['/gestion/formations', missionRequest?.id]"
							role="button"
						></i>

						<i
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
							*ngIf="
								!isProjectManager &&
								!isProfessionnelSAE &&
								missionRequest.missionType?.type === missionTypeName.REUNION
							"
							[routerLink]="['/gestion/meeting', missionRequest?.id]"
							role="button"
						></i>
					</div>
				</div>
			</div>
		</div>

		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="currentPage = 1"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option *ngIf="formations?.length >= 5" [value]="10">10</option>
						<option *ngIf="formations?.length >= 10" [value]="25">25</option>
						<option *ngIf="formations?.length >= 25" [value]="50">50</option>
						<option *ngIf="formations?.length >= 50" [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #modalSuppressionMultiple>
	<div class="modal-header">
		<h4 class="modal-title pull-left">
			Suppression de {{ labelInterventionPluralized }}
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalSuppressionMultipleRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row my-2">
			<div class="col-5">
				<span class="theme-main-color">Période :</span>
			</div>
			<div class="col">
				<span class="theme-main-color"
					>Du
					{{
						dateRange.value[0].getDate() +
							' ' +
							monthsFr[dateRange.value[0].getMonth()] +
							'
					' +
							dateRange.value[0].getFullYear()
					}}</span
				>
				<span class="mx-2 theme-main-color"
					>au
					{{
						dateRange.value[1].getDate() +
							' ' +
							monthsFr[dateRange.value[1].getMonth()] +
							'
					' +
							dateRange.value[1].getFullYear()
					}}</span
				>
			</div>
		</div>
		<div class="row my-2">
			<div class="col-5">
				<span class="theme-main-color">Compétences sélectionnées :</span>
			</div>
			<div class="col">
				<span
					class="theme-main-color"
					*ngIf="
						selectedCompetences.length === 0 || selectedCompetences.length === 3
					"
					>Toutes</span
				>
				<div
					*ngIf="
						!(
							selectedCompetences.length === 0 ||
							selectedCompetences.length === 3
						)
					"
				>
					<span
						class="theme-main-color"
						*ngFor="let comp of selectedCompetences"
						class="me-2"
						>{{ competences[comp] }}</span
					>
				</div>
			</div>
		</div>
		<div class="row my-2">
			<div class="col-5">
				<span class="theme-main-color">Total :</span>
			</div>
			<div class="col">
				<span class="theme-main-color"
					>{{ listSelectedMissionRequestDelete.length }}
					{{ labelInterventionPluralized }}</span
				>
			</div>
		</div>
		<div class="row mt-4 mb-2">
			<span class="theme-main-color"
				>Si ces informations vous semblent correctes valider la suppression
				<span class="theme-red-color fw-bold"
					>(cette action est irréversible)</span
				></span
			>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button"
			data-bs-dismiss="modal"
			(click)="modalSuppressionMultipleRef?.hide()"
		>
			Annuler
		</button>
		<button
			type="button"
			class="btn theme-red-button"
			(click)="validateDeleteListSelectedMission()"
			[disabled]="isBtnValidateDeleteListClicked"
		>
			Supprimer
		</button>
	</div>
</ng-template>

<ng-template #modalSuppressionAssignedToPlanning>
	<div class="modal-header">
		<h4 class="modal-title text-center">
			Une ou plusieurs {{ labelInterventionPluralized }} sont affectées dans le
			planning, voulez-vous vraiment les supprimer ?
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalSuppressionAssignedToPlanningRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="d-flex justify-content-evenly">
			<button
				class="btn theme-main-color-button"
				(click)="modalSuppressionAssignedToPlanningRef?.hide()"
			>
				Non
			</button>
			<button
				class="btn theme-red-button"
				(click)="
					deleteMissionsAssignedToPlanning = true;
					modalSuppressionAssignedToPlanningRef?.hide()
				"
			>
				Oui
			</button>
		</div>
	</div>
</ng-template>
